import { combineReducers } from 'redux';
import { ParticipantViewModel } from 'stageclip-common';

import { AllActions } from '../actions/allActions';
import { InternalActionTypes } from '../constants/actionTypes';
import { ById } from '../store/normalizedState';

import { FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS } from 'api/participants/participants.actions';
import * as ReducerHelper from './reducerHelper';

function allIdsReducer(state: string[] = [], action: AllActions): string[] {
  switch (action.type) {
    case InternalActionTypes.EventParticipantsLoaded:
    case InternalActionTypes.LiveAndHybridEventParticipantsLoadedAction:
    case InternalActionTypes.EventArchivedParticipantsLoaded:
    case FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantsUploaded:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantAdded:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantEdited:
    case InternalActionTypes.ParticipantReviewStatusUpdated:
    case InternalActionTypes.ParticipantBlacklistRemoved:
    case InternalActionTypes.ParticipantBlacklistAdded:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.MergedParticipants:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.ConvertedToUnknownParticipant:
      return ReducerHelper.addAllIds(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantDeleted:
    case InternalActionTypes.RemoveVgQaParticipant:
      return ReducerHelper.removeId(state, action.payload.participantId);
    case InternalActionTypes.ResetParticipantsList:
      return [];
    default:
      return state;
  }
}

function byIdReducer(state: ById<ParticipantViewModel> = {}, action: AllActions): ById<ParticipantViewModel> {
  switch (action.type) {
    case InternalActionTypes.EventParticipantsLoaded:
    case InternalActionTypes.LiveAndHybridEventParticipantsLoadedAction:
    case InternalActionTypes.EventArchivedParticipantsLoaded:
    case FETCH_QA_QUEUE_PARTICIPANTS_SUCCESS:
      return ReducerHelper.updateAll(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantsUploaded:
      return ReducerHelper.updateAll(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantAdded:
      return ReducerHelper.updateAll(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantEdited:
    case InternalActionTypes.ParticipantReviewStatusUpdated:
    case InternalActionTypes.ParticipantBlacklistRemoved:
    case InternalActionTypes.ParticipantBlacklistAdded:
      return ReducerHelper.updateAll(state, action.result.entities.participants);
    case InternalActionTypes.MergedParticipants:
      // eslint-disable-next-line no-case-declarations
      const updatedParticipantState = ReducerHelper.updateAll(state, action.result.entities.participants);

      return ReducerHelper.removeItem(updatedParticipantState, action.removedParticipantId);
    case InternalActionTypes.ConvertedToUnknownParticipant:
      return ReducerHelper.updateAll(state, action.result.entities.participants);
    case InternalActionTypes.EventParticipantDeleted:
    case InternalActionTypes.RemoveVgQaParticipant:
      return ReducerHelper.removeItem(state, action.payload.participantId);
    case InternalActionTypes.ResetParticipantsList:
      return {};
    default:
      return state;
  }
}

export const participantsReducer = combineReducers({
  allIds: allIdsReducer,
  byId: byIdReducer,
});
